module.exports = __webpack_public_path__ + "static/media/emptyblogs.bf6582ea.png";